import React from "react"

import Calendar from "~images/illustrations/calendar.svg"
import SupportNotice from "~components/shared/support-notice"
import COPY from "~config/copy-constants"

export default function CalendarEmptyView() {
    return (
        <SupportNotice
            title={COPY.EMPTY_CALENDAR_TITLE}
            supportMessage={COPY.EMPTY_CALENDAR_MESSAGE}
            imageSrc={Calendar}
        />
    )
}
